import { nameof } from "@libs/utils/name-of.utils.ts";
import { required } from "@libs/validation/fieldValidators.ts";
import { ClaimAdjustmentDocumentUploadFormValue } from "@shared-types/acc/claim-adjustment-document-upload-value.types.ts";

import { DocumentFormValidatorBase } from "./DocumentFormValidatorBase.tsx";

export class UploadDocumentValidator extends DocumentFormValidatorBase<ClaimAdjustmentDocumentUploadFormValue> {
  constructor() {
    super();
    this.forField(nameof("name"), required());
  }
}
